import { lookup } from '../content.ts';
import type { Event } from '../events.ts';
import { tileAt } from '../floorview.ts';
import { assertLeaderMayAct } from '../round.ts';
import { InvalidCommand, type RunState, floorOf } from '../state.ts';
import type { CommandHandler } from './types.ts';

/**
 * The leader, standing on the exit tile, leaves the floor. Enemies and the
 * floor are cleared and the party kept; the phase becomes `between_floors`.
 * The last floor has no exit tile: its boss's defeat ends the run
 * (combat.ts `defeat`), so `descend` there is refused. Does not end a round.
 */
export type DescendCommand = {
  readonly type: 'descend';
};

export const descend: CommandHandler<DescendCommand> = (ctx, state) => {
  const leader = assertLeaderMayAct(state, 'other');
  const dungeon = lookup(ctx.content.dungeons, state.dungeon);
  if (dungeon === null) throw new InvalidCommand('unknown_dungeon', `unknown dungeon ${state.dungeon}`, { dungeon: state.dungeon });
  if (state.floorNumber >= dungeon.floors) throw new InvalidCommand('last_floor_no_exit', 'the last floor has no exit; defeat the boss');
  if (tileAt(floorOf(state), leader.pos) !== 'exit') throw new InvalidCommand('not_on_exit', 'the leader is not on the exit');
  const next: RunState = {
    ...state,
    phase: 'between_floors',
    units: state.units.filter((u) => u.side === 'party'),
    floor: null,
  };
  const events: Event[] = [{ type: 'floor_cleared', floorNumber: state.floorNumber }];
  return { state: next, events };
};
